import stylez from './SearchStrip.module.css'
import Select from 'react-select';


const SearchStrip = ({
  size,
  setSize,
  pageSize,
  setPageSize,
  page,
  setPage,
  setDate,
  setSearchCriteria,
  date,
  custId,
  setDataChanged,
  setClearFilters,
  setCustID,
  changed,
  customerOptions,
  clearFilters,
  searchCriteria,
  customers,
  orderNumber,
  setOrderNumber,
  showTomorrowOnly // ✅ NEW: Added prop for tomorrow filter state
}) => {

  const customerHandler = (options) => {
    setCustID(options.value);
  };

  const handleDate = (e) => {
    setDate(e.target.value);
  };

  const filterData = () => {
    setPage(1);
    
    // ✅ UPDATED: Only set date filter if not showing tomorrow's orders
    if (date && !showTomorrowOnly) {
      setSearchCriteria((data) => ({ ...data, date: date }));
    }
    
    if (custId) {
      setSearchCriteria((data) => ({ ...data, custId: custId }));
    }
    
    console.log(orderNumber);
    if (orderNumber) {
      console.log(orderNumber);
      setSearchCriteria((data) => ({ ...data, orderNumber: orderNumber }));
    }
    
    setDataChanged(!changed);
    setClearFilters(true);
  };

  const handleOrderNumber = (e) => {
    setOrderNumber(e.target.value);
  }

  const filterHandler = (btnAction) => {
    if (btnAction === 'date') {
      setSearchCriteria((preValue) => ({ ...preValue, date: null }));
      setDate('');
    }
    if (btnAction === 'customer') {
      setSearchCriteria((preValue) => ({ ...preValue, custId: null }));
      setCustID(null);
    }
    if (btnAction === 'orderNumber') {
      setSearchCriteria((preValue) => ({ ...preValue, orderNumber: null }));
      setOrderNumber('');
    }
    setPage(1);
    setDataChanged(!changed);
  };

  const handlePageSize = (e) => {
    setSize(e.target.value);
  }

  const handlePageSizeClick = () => {
    setPageSize(size);
  }

  return (
    <div className={stylez.searchStripContainer}>
      <div className={stylez.searchStrip}>
        {/* ✅ UPDATED: Show conditional message for date picker */}
        <label>
          Search By Order Date: 
          {showTomorrowOnly && (
            <span style={{ color: '#6c757d', fontSize: '12px', marginLeft: '5px' }}>
              (Disabled - showing tomorrow's orders)
            </span>
          )}
        </label>
        <input
          className={stylez.datePicker}
          type='date'
          value={date}
          onChange={handleDate}
          disabled={showTomorrowOnly} // ✅ NEW: Disable when showing tomorrow's orders
          style={{
            opacity: showTomorrowOnly ? 0.5 : 1,
            cursor: showTomorrowOnly ? 'not-allowed' : 'pointer',
            backgroundColor: showTomorrowOnly ? '#f8f9fa' : 'white'
          }}
        />

        <label>Search By Customer Name: </label>
        <Select
          name='Customer'
          options={customerOptions}
          onChange={customerHandler}
          className={stylez.picker}
          value={customerOptions?.find(option => option.value === custId) || null} // ✅ IMPROVED: Show selected value
        />
        
        <label>Order Number</label>
        <input 
          type="number" 
          name="orderNumber" 
          value={orderNumber || ''} // ✅ IMPROVED: Handle null values
          onChange={handleOrderNumber}
        />
      
        <button onClick={filterData} className='searchBtn'>
          Search
        </button>

        <br />
      </div>
      
      <hr/>
      
      <div className={stylez.searchStrip}>
        <label>Number of Entries Per Page</label>
        <select onChange={handlePageSize} value={size}>
          <option value={20}>20 (default)</option>
          <option value={50}>50</option>
          <option value={100}>100</option>
        </select>
        <button 
          style={{
            backgroundColor:'#007bff',
            color:'white',
            marginLeft:'10px',
            padding:'10px 16px'
          }} 
          onClick={handlePageSizeClick}
        >
          Set
        </button>
        <label>Current Entries Per Page: {pageSize}</label>

        {clearFilters && (
          <div>
            {/* ✅ UPDATED: Only show date filter if not showing tomorrow's orders */}
            {searchCriteria.date && !showTomorrowOnly && (
              <span
                className='searchSpan'
                style={{ marginRight: '15px', marginLeft: '5px' }}
              >
                {searchCriteria.date}
                <button
                  className='spanBtn'
                  onClick={() => filterHandler('date')}
                >
                  {' '}
                  &times;
                </button>
              </span>
            )}
            
            {searchCriteria.custId && (
              <span className='searchSpan'>
                {customers
                  ?.filter((i) => i._id === searchCriteria.custId)
                  .map((i) => i.businessName)}
                <button
                  className='spanBtn'
                  onClick={() => filterHandler('customer')}
                >
                  &times;
                </button>
              </span>
            )}
            
            {searchCriteria.orderNumber && (
              <span className='searchSpan'>
                {searchCriteria.orderNumber}
                <button
                  className='spanBtn'
                  onClick={() => filterHandler('orderNumber')}
                >
                  &times;
                </button>
              </span>
            )}
          </div>
        )}
      </div>
    </div>
  )
}

export default SearchStrip;